import React, { Component } from 'react'
// components
import { OldButton } from 'components/Button'
import { FieldInput } from 'components/Form/Fields/FieldInput'
import Input from 'components/Form/Input'
import CircleBackground from 'components/common/CircleBackground'
// redux
import * as A from 'domain/env'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
import { push, Push } from 'connected-react-router'
// types
import { ButtonHtmlTypes, ButtonTypes, ComposeType } from 'types/common'
import { Classes } from 'jss'
// styles
import { sheet } from './sheet'
import injectSheet from 'react-jss'
// utils
import { signInValidate } from 'pages/Auth/validation'
import BackgroundWithFigures from 'components/common/BackgroundWithFigures'
import { Button } from 'components/ui/Button'
import { TextButton } from 'components/ui/TextButton'
import { otpLoginSelector } from 'domain/env'
import I from 'immutable'

interface OwnProps {
  classes: Classes
  signIn: (data: { email: string; password: string }) => void
  signInOtpRequest: (data: { email: string; password: string }) => void
  pushTo: Push
  otpLogin: I.Map<string, any> | null
}

type Props = InjectedFormProps<{ email: string; password: string }> & OwnProps

class LogIn extends Component<Props> {
  submit = (data: { email: string; password: string }) => {
    this.props.signIn(data)
  }

  submitOtpRequest = (data: { email: string; password: string }) => {
    this.props.signInOtpRequest(data)
  }

  onClick = (path: string) => {
    if (this.props.pushTo) this.props.pushTo(path)
  }

  resetPassword = () => {
    this.onClick('/reset-password')
  }

  signUp = () => {
    this.onClick('/sign-up')
  }

  render() {
    const { classes, handleSubmit, otpLogin } = this.props

    return (
      <form onSubmit={handleSubmit(this.submitOtpRequest)}>
        <div className={classes.content}>
          <div className={`${classes.logoFlexWrapper} d-flex`}>
            <div className={`${classes.logoWrapper} flex-center column flex1`}>
              <BackgroundWithFigures />

              <img className={classes.logo} style={{}} src="/skilentLogo.png" />
              <div className="text-logo">Welcome Back</div>
              <div className="text-logo-second">
                Skilent is growing <br /> day by day!
              </div>
            </div>
          </div>
          {/* <div className={'flex1 d-flex'}> */}
          <div className={`${classes.form} flex-center column`}>
            <div className={`${classes.formTitle} flex-center-align column`}>
              <div className="text-login-title">Login</div>
              <div className="text-login-second">Enter your credential to access your account.</div>
            </div>
            <div className={`d-flex column fill ${classes.formInner}`}>
              <FieldInput
                name="email"
                type="text"
                component={Input}
                title="Email"
                placeholder="email@domain.com"
                autoComplete="on"
                required
              />
              <div className={classes.forgotPasswordContainer}>
                <FieldInput
                  name="password"
                  type="password"
                  component={Input}
                  title="Password"
                  autoComplete="on"
                  isPassword={true}
                  placeholder="Password"
                  required
                />
                <div className={classes.forgotPassword}>
                  <TextButton onClick={this.resetPassword} className="text-12 text-main">
                    Forgot Password?
                  </TextButton>
                </div>
              </div>
              <div className={`${classes.buttonGroup} d-flex column fill`}>
                <Button size="md" fill label="Login" type="submit" />
                <div className={'text-12 text-regular flex-center-justify '}>
                  <span>
                    Don’t have an account?{' '}
                    <TextButton onClick={this.signUp} className="text-12 text-semibold">
                      Register here.
                    </TextButton>
                  </span>
                </div>
              </div>
            </div>
            {/*<LinkedinLogo name="Log in with Linked In" />*/}
          </div>
        </div>
      </form>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    (state: any) => ({
      otpLogin: otpLoginSelector(state)
    }),
    {
      signIn: A.signIn,
      signInOtpRequest: A.signInOtpRequest,
      pushTo: push
    }
  ),
  reduxForm({
    form: 'log-in',
    validate: signInValidate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  }),
  injectSheet(sheet)
)(LogIn)
